import { Card } from "@fanduel/og-fe-library";
import { NextSeo } from "next-seo";
import ErrorComponent from "@/components/empty/ErrorComponent";
import HorseRacingHeader from "@/components/horseRacing/header";
import RaceList from "@/components/horseRacing/raceList";
import BasicTerms from "@/components/horseRacing/widgets/basicTerms";
import { RACING_UPCOMING_RACES_PAGE_VIEWED } from "@/constants/amplitude";
import { SEO } from "@/constants/seo";
import { TermsT } from "@/types/horseRacing";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useOnce from "@/utils/hooks/useOnce";
import useUpcomingRaces from "@/utils/hooks/useUpcomingRaces";
import styles from "./container.module.scss";

interface HorseRacingContainer {
  title: string;
  description: string;
  initialTerms: TermsT;
}

const Container = ({
  title,
  description,
  initialTerms,
}: HorseRacingContainer) => {
  const { races, fetchNextPage, isLoading, isFetchingNextPage, isError } =
    useUpcomingRaces();
  const { logAmplitudeEvent } = useAmplitude();
  useOnce(() => {
    logAmplitudeEvent(RACING_UPCOMING_RACES_PAGE_VIEWED, {});
  });
  return (
    <div className={styles.container}>
      <NextSeo
        title={title}
        description={description}
        canonical={SEO.UPCOMING_RACES_URL}
        additionalMetaTags={[
          {
            name: "google-site-verification",
            content: SEO.GOOGLE_SITE_VERIFICATION_CODE,
          },
        ]}
      />
      <HorseRacingHeader title={title} />
      <div className={styles.contentContainer}>
        {races && races.length > 0 ? (
          <RaceList
            loading={isLoading || isFetchingNextPage}
            fetchNextPage={fetchNextPage}
            races={races}
          />
        ) : (
          <Card
            variant="elevation"
            elevation="mid"
            className={styles.errorContainer}
          >
            <ErrorComponent
              headline={
                isError ? "Content failed to load" : "No projections available"
              }
              subtext={
                isError ? (
                  <div>
                    <p>No Projections available.</p>
                    <p>Please check back later.</p>
                  </div>
                ) : (
                  "Please check back later."
                )
              }
              showCta={isError}
            />
          </Card>
        )}

        <div className={styles.widgetContainer}>
          <BasicTerms initialTerms={initialTerms} />
        </div>
      </div>
    </div>
  );
};

export default Container;
